import {call, put, takeLatest} from "redux-saga/effects";
import {
  fetchOrganizationDetails,
  fetchOrganizationImages,
  saveOrganizationImagesAsync,
} from "../AsyncActions/root.async";
import * as actions from "../action.constants";
import {storeOrganizationImages} from "../Actions/root.actions";

function* initialRequest() {
  try {
    const organizationResponse = yield call(fetchOrganizationDetails);
    if (organizationResponse?.data?.results) {
      yield put({
        type: actions.STORE_ORGANIZATION,
        payload: organizationResponse?.data?.results[0],
      });
      yield put({type: actions.APPLICATION_ERROR, notifyError: false});
    } else {
      yield put({type: actions.APPLICATION_ERROR, notifyError: true});
    }
  } catch (e) {
    yield put({type: actions.APPLICATION_ERROR, notifyError: true});
  }
}

function* fetchOrgImages() {
  try {
    const response = yield call(fetchOrganizationImages);
    if (response?.data) {
      yield put(storeOrganizationImages(response.data));
    }
  } catch (e) {
    yield put({type: actions.APPLICATION_ERROR, notifyError: true});
  }
}

function* saveOrgImages(action) {
  const {payload} = action;
  try {
    const response = yield call(saveOrganizationImagesAsync, payload);
    if (response?.data?.data) {
      yield put(storeOrganizationImages(response.data.data));
    }
  } catch (e) {
    yield put({type: actions.APPLICATION_ERROR, notifyError: true});
  }
}

export function* baseSaga() {
  yield takeLatest(actions.GET_ORGANIZATION, initialRequest);
  yield takeLatest(actions.GET_ORGANIZATION_IMAGES, fetchOrgImages);
  yield takeLatest(actions.SAVE_ORGANIZATION_IMAGES, saveOrgImages);
}
